import apiClient from './apiService';

export type InboxState = 'pending' | 'upcoming' | 'completed';
export type InboxBucket = 'overdue' | 'due' | 'upcoming' | 'completed';

export interface InboxItem {
    source: string;
    source_label: string;
    source_id: number;
    title: string | null;
    subtitle: string | null;
    role: string | null;
    due_date: string | null;     // YYYY-MM-DD
    created_on: string | null;   // ISO timestamp — when it entered the chronicle
    is_done: boolean;
    state: InboxState;           // filter dimension
    bucket: InboxBucket;         // urgency colour
    route_path: string | null;
}

export const inboxService = {
    /** The chronicle — every obligation across sources for the current user. */
    async list(): Promise<InboxItem[]> {
        const res = await apiClient.get('/api/v1/cal/inbox');
        return (res.data?.data ?? []) as InboxItem[];
    },
};
